module.exports = __webpack_public_path__ + "img/info_all.0152b2ee.svg";